import { render, staticRenderFns } from "./ZoneClothes.vue?vue&type=template&id=60d0b6a7&"
import script from "./ZoneClothes.vue?vue&type=script&lang=js&"
export * from "./ZoneClothes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports